import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Building2Icon,
  LayersIcon,
  LayoutDashboardIcon,
  MessageSquareTextIcon,
  SettingsIcon,
  ShieldCheckIcon,
} from 'lucide-react';
import type { NavGroup } from '@opengoal/ui';

/**
 * Sidebar navigation for the admin app.
 *
 * Intentionally a different tree from the platform app's — these are two
 * products that happen to share a design system. Do not merge them into a
 * shared navigation config.
 */
export function useNavGroups(): NavGroup[] {
  const { t } = useTranslation();

  return useMemo<NavGroup[]>(
    () => [
      {
        title: t('nav.overview'),
        items: [{ key: '/', label: t('nav.dashboard'), icon: <LayoutDashboardIcon /> }],
      },
      {
        title: t('nav.management'),
        items: [
          { key: '/agencies', label: t('nav.agencies'), icon: <Building2Icon /> },
          { key: '/tiers', label: t('nav.tiers'), icon: <LayersIcon /> },
          {
            key: '/sales-requests',
            label: t('nav.salesRequests'),
            icon: <MessageSquareTextIcon />,
          },
          { key: '/users', label: t('nav.adminUsers'), icon: <ShieldCheckIcon /> },
        ],
      },
      {
        title: t('nav.system'),
        items: [{ key: '/settings', label: t('nav.settings'), icon: <SettingsIcon /> }],
      },
    ],
    [t],
  );
}
